import { Culture } from '../../types';

export const apache: Culture = {
  name: 'Apache',
  languageFamily: 'Athabaskan',
  terms: [
    {
      word: 'Azeeʼ',
      phonetic: 'ah-zay-eh',
      description: 'Apache word meaning "medicine."'
    },
    {
      word: 'Chíʼį́įdii',
      phonetic: 'chee-eeh-dee',
      description: 'A term referring to "spirit" or "ghost."'
    },
    {
      word: 'Diyin',
      phonetic: 'dee-yin',
      description: 'Apache word for "holy" or "sacred."'
    },
    {
      word: 'Goyaałé',
      phonetic: 'go-yah-lay',
      description: 'Apache word meaning "the one who yawns," the name of Geronimo.'
    },
    {
      word: 'Ndee',
      phonetic: 'en-deh',
      description: 'Apache word meaning "The People," their name for themselves.'
    },
    {
      word: 'Shį́į́',
      phonetic: 'shee-eh',
      description: 'Word for "sun" in Apache.'
    },
    {
      word: 'Tú',
      phonetic: 'too',
      description: 'Apache word meaning "water."'
    },
    {
      word: 'Xón',
      phonetic: 'hohn',
      description: 'Apache word for "sun."'
    }
  ]
};